'use client';

import { useMemo } from 'react';
import type { Currency } from '../../constants';
import { useSiteconfigService } from './useSiteconfigService';

export const useGetShippingPolicyByCurrency = (currency: Currency) => {
  const { useGetShippingPolicyByCurrency: useGetPolicy } = useSiteconfigService();
  const query = useGetPolicy({ currency });

  return useMemo(
    () => ({
      shippingPolicy: query.data,
      isLoading: query.isLoading,
      isError: query.isError,
      isFetching: query.isFetching,
      isSuccess: query.isSuccess,
      refetch: query.refetch,
    }),
    [query.data, query.isLoading, query.isError, query.isFetching, query.isSuccess, query.refetch],
  );
};

